import { Text, type TextProps } from '@mantine/core';

interface TextCellProps extends Omit<TextProps, 'children'> {
  /** Значение для отображения */
  value: string | number | null | undefined;
  /** Заглушка при пустом значении (по умолчанию "—") */
  fallback?: string;
}

/**
 * Ячейка с текстом и автоматическим fallback.
 *
 * @example
 * cell: ({ row }) => <TextCell value={row.original.description} />
 */
const TextCell = ({ value, fallback = '—', ...textProps }: TextCellProps) => (
  <Text {...textProps}>{value != null && value !== '' ? String(value) : fallback}</Text>
);

export default TextCell;
